/** Lifecycle of a service firm on the platform (README section 1). */
export const TenantStatus = {
    PENDING: 'PENDING',
    APPROVED: 'APPROVED',
    PROBATION: 'PROBATION',
    ACTIVE: 'ACTIVE',
    SUSPENDED: 'SUSPENDED',
    REJECTED: 'REJECTED',
};
export const TENANT_STATUSES = Object.values(TenantStatus);
/** Statuses that may receive dispatch offers. */
export const DISPATCHABLE_TENANT_STATUSES = [
    TenantStatus.PROBATION,
    TenantStatus.ACTIVE,
];
/** Company registry statuses that hard-block onboarding. */
export const CompanyRegistryStatus = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
    STRUCK_OFF: 'STRUCK_OFF',
    INSOLVENT: 'INSOLVENT',
};
/** Registry statuses that must refuse tenant onboarding outright. */
export const BLOCKING_REGISTRY_STATUSES = [
    CompanyRegistryStatus.INACTIVE,
    CompanyRegistryStatus.STRUCK_OFF,
    CompanyRegistryStatus.INSOLVENT,
];
//# sourceMappingURL=tenant.js.map